/** First two segments of offer address, e.g. "Warszawa, Mokotów" from "Warszawa, Mokotów, ul. …". */
export const getPropertyCardDetailOverviewLocationLabel = (address: string) => {
    const [city, district] = address.split(",").map((part) => part.trim());

    if (city && district) {
        return `${city}, ${district}`;
    }

    return address;
};
/** First two segments of offer address, e.g. "Warszawa, Mokotów" from "Warszawa, Mokotów, ul. …". */
export const getPropertyCardDetailOverviewLocationLabel = (address: string) => {
    const [city, district] = address.split(",").map((part) => part.trim());

    if (city && district) {
        return `${city}, ${district}`;
    }

    return address;
};
